@let tierError = tiers().errors?.['tiers'];

@if (tierError; as error) {
    <div class="error-banner" role="alert">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'packages.pricing.errors.' + error.reason | translate: { index: (error.tierIndex ?? 0) + 1 } }}</span>
    </div>
} @else if (tiers().length === 0) {
    <p class="empty">{{ 'packages.pricing.tier.empty' | translate }}</p>
}

<ul class="tiers">
    @for (group of tiers().controls; track $index) {
        <li>
            <app-tier-row [group]="group" [index]="$index" (remove)="removeTier($index)" />
        </li>
    }
</ul>

<p-button
    [label]="'packages.pricing.tier.add' | translate"
    icon="pi pi-plus"
    [outlined]="true"
    severity="secondary"
    size="small"
    type="button"
    (onClick)="addTier()"
/>
